import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useSelector } from "react-redux";
import PageHelmet from "modules/pageSetting/PageHelmet";
import UserProfileWindowContainer from "modules/userProfileWindow/UserProfileWindowContainer";
import { NetworkTracker } from "modules/network";
import UserpilotContextProvider from "modules/userpilot/UserpilotContext";
import { TestRunner } from "modules/systemCheck/components/TestRunner";
import { Monitoring } from "modules/monitoring/components/Monitoring";
import MainNavigation from "navigation/MainNavigation";
import { GlobalHelpChat, useHelpChatLoader } from "modules/helpChat";
import { selectUser } from "modules/auth/redux/selectors";
import { NotificationContainer } from "modules/notification";
import { DialogNotificationContainer } from "modules/dialogNotification/components/DialogNotificationContainer";
import MissingFullNameDialog from "modules/auth/components/MissingFullNameDialog";
import { DeviceLoader } from "modules/audioVideo/components/DeviceLoader";
import { CustomDomainHandler } from "modules/settings/components/CustomDomainHandler";
import { EventLoader } from "modules/event/components/EventLoader";
import { BrandNameLoader } from "modules/settings/components/BrandNameLoader";
import { ManageAppsumoSubscription } from "modules/appsumo/ManageAppsumoSubscription";
import { WatchDeployedAppVersion } from "modules/version/components/WatchDeployedAppVersion";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { selectIsInBroadcast } from "modules/broadcast/redux/selectors";
import { RemoTheme } from "@remo-co/ui-core/theme";
import { useEffect } from "react";
import BackgroundInitialization from "./BackgroundInitialization";
import MobileHandler from "./MobileHandler";
import { styles } from "./styles";

const App = (): JSX.Element => {
  const user = useSelector(selectUser);
  const isInBroadcast = useSelector(selectIsInBroadcast);

  useHelpChatLoader();

  useEffect(() => {
    if (isInBroadcast) {
      localStorage.setItem("theme", RemoTheme.dark);
    } else {
      localStorage.setItem("theme", RemoTheme.light);
    }
  }, [isInBroadcast]);

  return (
    <div role="application">
      <PageHelmet />
      <div className="app-container" role="presentation">
        <GlobalHelpChat />
        <DeviceLoader />
        <NotificationContainer />
        <DialogNotificationContainer />
        <MissingFullNameDialog />
        <ManageAppsumoSubscription />
        <CustomDomainHandler />
        <EventLoader />
        <BrandNameLoader />
        <ReactQueryDevtools initialIsOpen={false} position="bottom" />
        <div>
          <UserpilotContextProvider>
            <Box sx={styles.mainContainer}>
              <MainNavigation />
            </Box>
          </UserpilotContextProvider>
        </div>
        <MobileHandler />
      </div>
      <UserProfileWindowContainer />
      <NetworkTracker />
      <BackgroundInitialization />
      <WatchDeployedAppVersion />
      <TestRunner />
      <Monitoring user={user} />
    </div>
  );
};

export default App;
